import axios from 'src/utils/axios';

export const getArtemisProductHistory = ({
  ModelCode, ProductionYear, ProductionMonth, SerialNumber, AttributeId
}) => axios.get(`/GetSiriusProductHistory/${ModelCode}/${ProductionYear}/${ProductionMonth}/${SerialNumber}/${AttributeId}`);
